import { Injectable, NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TransitionService {
  constructor(private zone: NgZone) {}

  run(changeFn: () => void): void {
    const anyDoc = document as any;

    // Bind the method to preserve the correct 'this'
    const start: undefined | ((cb: () => void | Promise<void>) => void) =
      typeof anyDoc.startViewTransition === 'function'
        ? anyDoc.startViewTransition.bind(anyDoc) // ✅ bind to document
        : undefined;

    if (start) {
      start(() => this.zone.run(changeFn));
    } else {
      // Fallback: just perform the change (or trigger your FLIP here)
      this.zone.run(changeFn);
    }
  }
}
